
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import I18n from "../../common/I18n";
import { checkServiceExistance, toScreenConfigFormat } from "../../helpers/common";
import { ScreenKeys } from "../../containers/constants";
// import { setGridConfigSetting } from "../api/DisplaySettings";
import { alertMessage } from "../../common/Common";
import { getQuotesCols, getSubOrderCols} from "../../components/common/columnDefs";
import { getStoredColumns,getConfiguredColumns } from "../../components/orders/helpers";
import { setGridConfigSetting } from "../../api/DisplaySettings";
import { checkboxColumn } from "../../components/common/columnDefs";
// import MyGridComponent from "../dispatches/ReactDataGrid";
import MyGridComponent from "../../components/dispatches/ReactDataGrid";

const SubordersGridLIst= (props) =>{
  const { rawDataSource, accountCodesWithExceededLimit = [],userContext, tableName,orgData, onRowSelection, onSort, vhTypes, displayConfiguration, accountsList, zonesList, setCurrentGridRef, handleColumnVisibilityChange, modalOpen, closeModal, isRowSelectable,showRerrangeableModal,dispContext} = props;
  const { updateColWidths, currentUser } = userContext || {};
  const [ filteredRowData, setFilteredRowData ] = useState([]);
  const tableColMapping = {
    [ScreenKeys.SUBORDERS_LISTING] : getSubOrderCols(props)
  };

  const allCols = _.get(tableColMapping, tableName, []);
  const [ columnDefs, setColumnDefs ] = useState(allCols);

  useEffect(() => {
    const modifiedData = rawDataSource?.map((order) => {
        
    //   if (accountCodesWithExceededLimit.includes(order.account_code)) {
    //     return {
    //       ...order,
    //       account_limit_exceeded: true
    //     };
    //   } else {
        return order;
    //   }
    });
    setFilteredRowData(modifiedData || []);
    ProcessCols()
  }, [ rawDataSource ]);

  const ProcessCols = () => {
    
    const columns = [];
    const hasSomeConfiguration = props.displayConfiguration && (props.displayConfiguration.userConfiguration || props.displayConfiguration.orgConfiguration);
    const storedColumns = getStoredColumns(currentUser, tableName);

    if (!hasSomeConfiguration) {
      columns.push(...allCols);
    } else {
      const { userConfiguration = {} } = props.displayConfiguration;
      const { orgConfiguration = {} } = props.displayConfiguration;
      columns.push(...getConfiguredColumns(allCols, storedColumns, userConfiguration, orgConfiguration, tableName));
    }

    setColumnDefs(columns);
  };


  useEffect(() => {
    ProcessCols();
  }, [ props.displayConfiguration, props.vhTypes ]);

  const handleSaveRowIdx = useCallback((colState) => {
    let newOrder = _.compact(colState
      .filter((col) => col.isVisible) // filter out columns where isVisible is false
      .map((col) => col.field || col.colId));    
    const { currentUser } = userContext;
    const { _id: userId, currentOrg } = currentUser;
    const data = {
      organization_id: currentOrg._id,
      config_type: tableName,
      config_value: newOrder,
      user_id: userId
    };
    setGridConfigSetting(data).then((result) => {
      if (result.success) {
        dispContext("userConfiguration", {
          ...props.displayConfiguration.userConfiguration,
          [tableName]: [...newOrder],
        });
        alertMessage(I18n.t("messages.saved"), "success", 10);
      } else {
        alertMessage(result.errors[0], "error", 10);
      }
    }
    );

  }, [ tableName ]);

  const handleSaveColIdx = useCallback((colState) => {
    let newOrder = _.compact(colState
      .filter((col) => !col.hide) // filter out columns where isVisible is false
      .map((col) => col.field || col.colId));
    const { currentUser } = userContext;
    const { _id: userId, currentOrg } = currentUser;
    const data = {
      organization_id: currentOrg._id,
      config_type: tableName,
      config_value: newOrder,
      user_id: userId
    };
    setGridConfigSetting(data).then((result) => {
      if (result.success) {
        dispContext("userConfiguration", {
          ...props.displayConfiguration.userConfiguration,
          [tableName]: [...newOrder],
        });
        alertMessage(I18n.t("messages.saved"), "success", 10);
      } else {
        alertMessage(result.errors[0], "error", 10);
      }
    }
    )
  }
    , [ tableName,dispContext,displayConfiguration,currentUser ]);

    const handleSaveColumnWidth = useCallback(
      ({ colId, newWidth, colState }) => {
        const newColumnDefs = colState.map((col) => {
          if (col.colId === '0') {
            return checkboxColumn;
          } else if (col.colId === 'items') {
            return itemsColdef;
          } else {
            const foundCol = _.find(columnDefs, { field: col.colId });
            return { ...foundCol, width: col.width };
          }
        });
        setColumnDefs(newColumnDefs);
        const finalColumnDefs = colState.map((col) => ({ key: col.colId, width: col.width }));
        updateColWidths(tableName, toScreenConfigFormat(finalColumnDefs));
      },
      [columnDefs,dispContext, tableName, updateColWidths]
    );

  const handleRowChecked = (colId, checked) => {
    const newColumnDefs = columnDefs.map((col) => {
      if (col.field || col.colId === colId) {
        return { ...col, hide: !checked };
      }
      return col;
    });
    setColumnDefs(newColumnDefs);
  };

  // setGridConfigSetting(data).then((result) => {
  //   if (result.success) {
  //     dispContext("userConfiguration", {
  //       ...displayConfiguration.userConfiguration,
  //       [tableName]: [...newOrder],
  //     });
  //     alertMessage(I18n.t("messages.saved"), "success", 10);
  //   } else {
  //     alertMessage(result.errors[0], "error", 10);
  //   }
  // });
  return (
    <MyGridComponent
    // organizationSettings={props.organizationSettings}
    columnDefs={ columnDefs }
    LoadingOverlay={false}
    rowData={ filteredRowData }
    // onRowSelection={onRowSelection }
    // onSortChanged={ (colState) => {
    //   const sortedCol = colState[ 0 ];
    //   const { colId, sort } = sortedCol; 
    //   onSort(colId, sort);
    // }
    // }
    totalCols={ allCols }
    // saveColumnWidth={handleSaveColumnWidth}
    // onColumnMoved={handleSaveColIdx}
    // onRowMoved={handleSaveRowIdx}
    // showPagination={props.showPagination}
    // pagination={props.pagination}
    // getPageWiseData={props.getPageWiseData}
    // onPerPageChanged={props.onPerPageChanged}    
    // handleRowSelection={handleRowChecked}
    // setCurrentGridRef={setCurrentGridRef }
    // handleColumnVisibilityChange={handleColumnVisibilityChange }
    // showRerraangeModal={showRerrangeableModal}
    // closeModal={ closeModal }
    // isRowSelectable={ isRowSelectable }
    // handleSave={handleSave}
    rawDataSource ={rawDataSource}
    RowHeight={props.RowHeight}
    />
  )
}

export default SubordersGridLIst;

SubordersGridLIst.propTypes = {
    rawDataSource: PropTypes.array,
    accountCodesWithExceededLimit: PropTypes.array,
    userContext: PropTypes.object,
    tableName: PropTypes.string,
    onRowSelection: PropTypes.func,
    onSort: PropTypes.func,
    vhTypes: PropTypes.array,
    displayConfiguration: PropTypes.object,
    accountsList: PropTypes.array,
    zonesList: PropTypes.array,
    handleColumnVisibilityChange: PropTypes.func,
    modalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    isRowSelectable: PropTypes.func,
    showRerrangeableModal: PropTypes.func,
    dispContext: PropTypes.func
  };
  
  SubordersGridLIst.defaultProps = {
    rawDataSource: [],
    accountCodesWithExceededLimit: [],
    userContext: {},
    tableName: '',
    onRowSelection: () => { },
    onSort: () => { },
    vhTypes: [],
    displayConfiguration: {},
    accountsList: [],
    zonesList: [],
    handleColumnVisibilityChange: () => { },
    modalOpen: false,
    closeModal: () => { },
    isRowSelectable: () => { },
    showRerrangeableModal: () => { },
    dispContext: () => { }
  
  };

  